<template>
  <div
    class="SetupEffortGauge">
    <div
      class="_gauge">
      <h6>LOW</h6>
      <h6>HIGH</h6>
    </div>
    <div
      class="_label"
      :style="computedLabelStyle">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SetupEffortGauge',

  props: {
    difficulty: { type: Number, default: 2 },
    label:      { type: String, default: '' },
  },

  computed: {
    computedLabelStyle() {
      return {
        left: `${Math.floor((this.difficulty / 10) * 100)}%`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.SetupEffortGauge {
  position: relative;
  padding-bottom: 20px;
  white-space: nowrap;
}

.SetupEffortGauge ._gauge {
  display: flex;
  width: 100%;
  height: 24px;
  padding: 0 8px 4px 8px;
  color: $white;
  align-items: center;
  justify-content: space-between;
  background: $light-blue;
  background: linear-gradient(270deg, #4D8CBA, #99CCEE 31.95%, #8DD5BE 74.64%, #69BEA8);
  box-shadow: inset 0 0 7px rgba($black, .24);
}

.SetupEffortGauge ._label {
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  font-size: 12px;
  transform: translateX(-50%);
  &:before {
    $size: 12px;
    content: "";
    display: block;
    position: absolute;
    top: -$size;
    right: 0;
    left: 0;
    width: $size;
    height: $size;
    margin-left: auto;
    margin-right: auto;
    border-bottom: $size solid $white;
    border-left: $size solid transparent;
    border-right: $size solid transparent;
  }
}
</style>
